import React from "react";
import { Image, Icon } from "semantic-ui-react";
import { ensureHttpsImageUrl } from "../../../../app/common/util/util";

// Shared property photo + fallback - the one pattern already used elsewhere
// in the app (TransactionCardList.jsx, TransactionAllListItem.jsx,
// StrategyCreditConfirmModal.jsx: `pic ? ensureHttpsImageUrl(pic) : placeholder`)
// but that this feature's own strategy pages never actually used - both the
// Buyer property row and the Compare Homes table hardcoded the placeholder
// image even when a real transaction photo was available. Never fabricates
// a photo: a property with no known `pic` (every PREVIOUS Buyer property -
// no photo is persisted per historical property today) always gets the
// same neutral placeholder, never a guessed/stock image.
export default function PropertyPhoto({ pic, width = 110, height = 82, borderRadius = 6, style }) {
  const src = pic ? ensureHttpsImageUrl(pic) : "/assets/placeholder-house.png";
  return (
    <Image
      src={src}
      alt="Property"
      style={{ width, height, objectFit: "cover", borderRadius, flexShrink: 0, background: "#f3f4f5", ...style }}
    />
  );
}

// Compact variant used where an icon reads cleaner than a tiny stretched
// photo (e.g. a collapsed previous-property row) - still photo-first when a
// real `pic` is known, icon-only fallback otherwise.
export function PropertyPhotoOrIcon({ pic, size = 44, style }) {
  if (pic) {
    return <PropertyPhoto pic={pic} width={size} height={size} borderRadius={size / 4} style={style} />;
  }
  return (
    <div
      style={{
        width: size, height: size, borderRadius: size / 4, background: "#f3f4f5",
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, ...style,
      }}
    >
      <Icon name="home" style={{ color: "#aaaaaa", margin: 0, fontSize: `${size * 0.45}px` }} />
    </div>
  );
}
